import React from 'react';
import { Layout } from '../components/Layout';
import { Card } from '../components/ui/Card';
import { useTranslation } from '../i18n';
export function PrivacyPolicyPage() {
  const {
    t
  } = useTranslation();
  return <Layout data-id="element-3513" data-mp="2mt0tozipkmfw">
      <section className="bg-teal-900 text-white py-16" data-id="element-3514" data-mp="2mt98iwye61tq">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-3515" data-mp="2rsvm57i4tk32">
          <h1 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-3516" data-mp="2ruykcetfujiv">
            Privacy Policy
          </h1>
          <p className="text-teal-100" data-id="element-3517" data-mp="2isgulqekr8r4">Last updated: 5 February 2026</p>
        </div>
      </section>

      <section className="py-16 bg-gray-50" data-id="element-3518" data-mp="243kse9z78pyf">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-3519" data-mp="244vt20xclhlb">
          <Card className="p-8 md:p-12 prose prose-teal max-w-none" data-id="element-3520" data-mp="292e2rtj6w0ud">
            <p className="lead" data-id="element-3521" data-mp="290b5cofpj5fm">
              Dentico Dental Clinic Ltd is committed to protecting your privacy
              and handling personal data transparently and securely.
            </p>

            <div className="bg-teal-50 p-6 rounded-xl my-8 not-prose" data-id="element-3522" data-mp="1z6asg0e6ovwc">
              <h3 className="text-lg font-bold text-teal-900 mb-2" data-id="element-3523" data-mp="29q1wrllppt2o">
                Data Controller
              </h3>
              <p className="text-teal-800" data-id="element-3524" data-mp="24umnl6ynglcl">Dentico Dental Clinic Ltd</p>
              <p className="text-teal-800" data-id="element-3525" data-mp="2johsk1vopqii">Company No.: 15399534</p>
              <p className="text-teal-800" data-id="element-3526" data-mp="2eq6ibq1h9dzr">
                Address: 360–364 City Road, London EC1V 2PY, United Kingdom
              </p>
              <p className="text-teal-800" data-id="element-3527" data-mp="1r1n6j0j7yj2x">Email: info@denticoclinic.co.uk</p>
              <p className="text-teal-800" data-id="element-3528" data-mp="1m33lr3gd3dc5">Phone: +44 7345 197820</p>
            </div>

            <h3 data-id="element-3529" data-mp="20r6s4dybgr1h">We may collect:</h3>
            <ul data-id="element-3530" data-mp="20shy8kf8iavr">
              <li data-id="element-3531" data-mp="20t1elwp8kr7o">
                name, phone number, email address, enquiry/booking details,
              </li>
              <li data-id="element-3532" data-mp="18anq4npsihl9">
                technical website data (IP, browser/device, pages viewed),
              </li>
              <li data-id="element-3533" data-mp="13bsu2k2tawj7">any data you voluntarily submit via website forms.</li>
            </ul>

            <h3 data-id="element-3534" data-mp="1szojzv3ti7rt">We use your data to:</h3>
            <ul data-id="element-3535" data-mp="1syn5thri955v">
              <li data-id="element-3536" data-mp="1sz6oj0ozbxky">respond to enquiries and appointment requests,</li>
              <li data-id="element-3537" data-mp="1x0ibeyggy4pg">manage bookings and communications,</li>
              <li data-id="element-3538" data-mp="1wyxej26om9of">improve our website and services,</li>
              <li data-id="element-3539" data-mp="21tbbh90zsov7">send marketing updates only where consent is provided,</li>
              <li data-id="element-3540" data-mp="26rcujtyf4o6o">comply with legal and regulatory obligations.</li>
            </ul>

            <h3 data-id="element-3541" data-mp="1a13zilwfm0n5">Lawful bases include:</h3>
            <ul data-id="element-3542" data-mp="1a2f06cukysa1">
              <li data-id="element-3543" data-mp="1a2x4zxvb6etk">contract / steps at your request before contract,</li>
              <li data-id="element-3544" data-mp="1e379f63gcx6b">legal obligation,</li>
              <li data-id="element-3545" data-mp="1e48wk8xqta4e">legitimate interests,</li>
              <li data-id="element-3546" data-mp="1j1912fey24te">consent (where required, e.g. marketing/certain cookies).</li>
            </ul>

            <h3 data-id="element-3547" data-mp="1o0vfutaf7t4b">Data Sharing & Retention</h3>
            <p data-id="element-3548" data-mp="1nyioxqmoq8f4">
              We do not sell your personal data. We may share data with trusted
              service providers (IT/hosting/booking/analytics/professional
              advisers) only where necessary and lawful.
            </p>
            <p data-id="element-3549" data-mp="nsykf29cd10n">
              We retain personal data only as long as needed for the purposes
              collected and in line with legal/regulatory requirements.
            </p>

            <h3 data-id="element-3550" data-mp="e2c75ep3kml4">Your Rights</h3>
            <p data-id="element-3551" data-mp="e1kcc63bqsvw">
              You have rights to access, rectify, erase (where applicable),
              restrict, object, data portability, and withdraw consent where
              consent is used.
            </p>

            <div className="border-t border-gray-200 pt-8 mt-8" data-id="element-3552" data-mp="53ig03ujcoey">
              <p data-id="element-3553" data-mp="2kyzul9i0f1">
                For privacy requests, contact:{' '}
                <a href="mailto:info@denticoclinic.co.uk" className="text-teal-600 font-medium hover:underline" data-id="element-3554" data-mp="3r95lr24aam69">
                  info@denticoclinic.co.uk
                </a>
              </p>
            </div>
          </Card>
        </div>
      </section>
    </Layout>;
}